import { ChangeDetectorRef, Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApplicationService } from '../../core/services/application.service';
import { ApplicationItemDetailModel } from '../../core/models/applications/ApplicationItemDetail.model';
import { Location as AngularLocation } from '@angular/common';

interface ApplicationMediaItem {
    image: string;
    type: 'image' | 'video';
    source?: string;
}

interface ApplicationFeatureItem {
    title: string;
    description: string;
    icon: string;
}

@Component({
    selector: 'app-product-profile',
    standalone: false,
    templateUrl: './application-profile.component.html',
    styleUrl: './application-profile.component.css'
})
export class ApplicationProfileComponent {

    activeTab = 'overview';
    isWishlisted = false;
    requirementMode: 'minimum' | 'recommended' = 'minimum';

    public application!: ApplicationItemDetailModel;

    tabs = [
        { id: 'overview', name: 'Genel Bakış', count: null },
        { id: 'media', name: 'Medya', count: null },
        { id: 'features', name: 'Özellikler', count: null },
        { id: 'requirements', name: 'Sistem Gereksinimleri', count: null },
        { id: 'comments', name: 'Yorumlar', count: null },
        { id: 'support', name: 'Destek', count: null }
    ];
    elementRef: any;
    renderer: any;
    slug: string = '';
    pid: number = 0;
    constructor(private router: Router, private location: AngularLocation,private route: ActivatedRoute, private appSvc: ApplicationService, private readonly cdr: ChangeDetectorRef) {
    }

    ngOnInit(): void {
       this.route.paramMap.subscribe(params => {
        const slug = params.get('slug');
        const pidValue = params.get('pid');
        const pid = Number(pidValue);

        if (!slug?.trim() || !pidValue || !Number.isSafeInteger(pid) || pid <= 0) {
            this.location.back();
            return;
        }

        this.slug = slug;
        this.pid = pid;
    });


        this.appSvc.GetApplication(this.slug,this.pid).subscribe(result => {
            this.application = result.data;
            this.cdr.detectChanges();
        });

     //   this.applyRandom3DBackground();
    }

    StartApplication(): void {
    console.log('Kullanmaya Başla');
        }

    get BannerImage(): string {
        return this.application?.bannerSrc.default || this.application?.bannerImageUrl || '';
    }

    get CoverImage(): string {
        return this.application?.logoSrc.default || this.application?.coverImageUrl || '';
    }

    get LogoImage(): string {
        return this.application?.logoSrc.default || this.application?.logoUrl || this.application?.iconUrl || '';
    }

    get VendorInitial(): string {
        const name = this.application?.developerName || this.application?.publisherName || this.application?.name || 'A';
        return name.charAt(0).toUpperCase();
    }

    get AllMedia(): ApplicationMediaItem[] {
        const media: ApplicationMediaItem[] = [];

        if (this.application?.videoSrc || this.application?.videoUrl) {
            const video = this.application.videoSrc || this.application.videoUrl;
            const videoPoster = this.application?.screenshotSrc?.[0] || this.application?.screenshotUrls?.[0] || this.BannerImage || this.CoverImage;

            if (videoPoster) {
                media.push({ image: videoPoster, type: 'video', source: video.default });
            }
        }

        const screenshots = [
            ...(this.application?.screenshotSrc || []),
            ...(this.application?.screenshotUrls || [])
        ].filter((value, index, array) => !!value && array.indexOf(value) === index);

        screenshots.forEach(image => media.push({ image, type: 'image' }));

        return media;
    }

    get PreviewMedia(): ApplicationMediaItem[] {
        return this.AllMedia.slice(0, 4);
    }

    get GalleryMedia(): ApplicationMediaItem[] {
        return this.AllMedia.slice(0, 5);
    }

    get RemainingMediaCount(): number {
        return Math.max(this.AllMedia.length - 4, 0);
    }

    get RemainingGalleryCount(): number {
        return Math.max(this.AllMedia.length - 5, 0);
    }

    get FeatureItems(): ApplicationFeatureItem[] {
        const result: ApplicationFeatureItem[] = [];

        if (this.application?.isVerified) {
            result.push({
                title: 'Doğrulanmış Uygulama',
                description: 'Uygulama ve yayıncı bilgileri doğrulanmıştır.',
                icon: 'bi bi-patch-check'
            });
        }

        if (this.application?.requiresOnlineAccess) {
            result.push({
                title: 'Online Erişim',
                description: 'Uygulamanın çalışması için internet bağlantısı gerekir.',
                icon: 'bi bi-globe2'
            });
        }

        if (this.application?.supportedPlatforms?.length) {
            result.push({
                title: 'Çoklu Platform',
                description: this.application.supportedPlatforms.slice(0, 4).join(', '),
                icon: 'bi bi-laptop'
            });
        }

        if (this.application?.isPublished) {
            result.push({
                title: 'Yayında',
                description: 'Uygulama aktif olarak yayınlanmakta ve kullanılabilmektedir.',
                icon: 'bi bi-rocket-takeoff'
            });
        }

        if (result.length < 4 && this.application?.requiresInstallation) {
            result.push({
                title: 'Kurulum Gerekli',
                description: 'Kullanım öncesinde istemci veya ilgili bileşenlerin kurulması gerekir.',
                icon: 'bi bi-download'
            });
        }

        if (result.length < 4 && this.application?.requiresConfiguration) {
            result.push({
                title: 'Yapılandırılabilir',
                description: 'Uygulama ihtiyaca göre yapılandırılabilir ayarlar sunar.',
                icon: 'bi bi-sliders'
            });
        }

        if (result.length < 4 && this.application?.isFree) {
            result.push({
                title: 'Ücretsiz Erişim',
                description: 'Bu uygulama ücretsiz kullanım seçeneği sunmaktadır.',
                icon: 'bi bi-gift'
            });
        }

        return result.slice(0, 4);
    }

    get ActiveRequirements(): string[] {
        if (this.requirementMode === 'recommended') {
            return this.application?.recommendedRequirements || [];
        }

        return this.application?.minimumRequirements || [];
    }

    get ViewProgress(): number {
        return this.NormalizeProgress(this.application?.viewCount || 0, Math.max(this.application?.viewCount || 0, 1));
    }

    get DownloadProgress(): number {
        const max = Math.max(this.application?.viewCount || 0, this.application?.downloadCount || 0, 1);
        return this.NormalizeProgress(this.application?.downloadCount || 0, max);
    }

    get RatingProgress(): number {
        return Math.min(Math.max((this.application?.ratingAverage || 0) * 20, 0), 100);
    }

    get ActiveTabName(): string {
        return this.tabs.find(x => x.id === this.activeTab)?.name ?? '';
    }

    SetActiveTab(tabId: string): void {
        this.activeTab = tabId;
    }

    ToggleWishlist(): void {
        this.isWishlisted = !this.isWishlisted;
    }

    OpenMedia(media: ApplicationMediaItem): void {
        if (media.type === 'video' && media.source) {
            this.OpenExternal(media.source);
            return;
        }

        this.OpenExternal(media.image);
    }

    OpenVendor(): void {
        if (!this.application?.vendorId) return;
        this.router.navigate(['/marketplace/vendor', this.application.vendorId]);
    }

    GoApplications(): void {
        this.router.navigate(['/marketplace']);
    }

    GoBack(): void {
        window.history.back();
    }

    ShareApplication(): void {
        const url = window.location.href;

        if (navigator.share) {
            navigator.share({
                title: this.application?.name || 'Uygulama',
                text: this.application?.shortDescription || '',
                url
            }).catch(() => undefined);
            return;
        }

        navigator.clipboard?.writeText(url);
    }

    OpenExternal(url: string): void {
        if (!url) return;
        window.open(url, '_blank', 'noopener,noreferrer');
    }

    GetTabIcon(tabId: string): string {
        switch (tabId) {
            case 'overview': return 'bi bi-display';
            case 'media': return 'bi bi-image';
            case 'features': return 'bi bi-gear';
            case 'requirements': return 'bi bi-pc-display';
            case 'comments': return 'bi bi-chat-left';
            case 'support': return 'bi bi-life-preserver';
            default: return 'bi bi-circle';
        }
    }

    private NormalizeProgress(value: number, max: number): number {
        if (value <= 0 || max <= 0) return 0;
        return Math.min(Math.max((value / max) * 100, 8), 100);
    }



    private applyRandom3DBackground(): void {
     const host = this.elementRef.nativeElement;

    const random = (min: number, max: number): number => {
        return Math.floor(Math.random() * (max - min + 1)) + min;
    };

    const randomFloat = (min: number, max: number): number => {
        return Math.random() * (max - min) + min;
    };


    /* ========================================================
       RANDOM POSITIONS
    ======================================================== */

    this.renderer.setStyle(
        host,
        '--bg-x1',
        `${random(3, 32)}%`
    );

    this.renderer.setStyle(
        host,
        '--bg-y1',
        `${random(3, 38)}%`
    );


    this.renderer.setStyle(
        host,
        '--bg-x2',
        `${random(68, 97)}%`
    );

    this.renderer.setStyle(
        host,
        '--bg-y2',
        `${random(8, 55)}%`
    );


    this.renderer.setStyle(
        host,
        '--bg-x3',
        `${random(18, 82)}%`
    );

    this.renderer.setStyle(
        host,
        '--bg-y3',
        `${random(62, 98)}%`
    );


    /* ========================================================
       RANDOM SIZES
    ======================================================== */

    this.renderer.setStyle(
        host,
        '--orb-size-1',
        `${random(480, 850)}px`
    );

    this.renderer.setStyle(
        host,
        '--orb-size-2',
        `${random(520, 950)}px`
    );

    this.renderer.setStyle(
        host,
        '--orb-size-3',
        `${random(420, 780)}px`
    );


    /* ========================================================
       RANDOM COLORS
    ======================================================== */

    const hue1 = random(195, 225);
    const hue2 = random(325, 355);
    const hue3 = random(245, 275);

    this.renderer.setStyle(
        host,
        '--orb-color-1',
        `hsla(${hue1}, 88%, 63%, ${randomFloat(0.17, 0.30).toFixed(2)})`
    );

    this.renderer.setStyle(
        host,
        '--orb-color-2',
        `hsla(${hue2}, 88%, 66%, ${randomFloat(0.10, 0.20).toFixed(2)})`
    );

    this.renderer.setStyle(
        host,
        '--orb-color-3',
        `hsla(${hue3}, 82%, 66%, ${randomFloat(0.11, 0.22).toFixed(2)})`
    );


    /* ========================================================
       RANDOM ROTATION
    ======================================================== */

    this.renderer.setStyle(
        host,
        '--bg-rotate',
        `${random(-4, 4)}deg`
    );


    /* ========================================================
       RANDOM SPEED
    ======================================================== */

    this.renderer.setStyle(
        host,
        '--bg-duration',
        `${random(16, 28)}s`
    );
}
}
